module.exports = __webpack_public_path__ + "img/mstile-150x150.45013d22.png";